import { NumericBoolean } from '@bilibili-maoer/web-utils'

import type { Pagination } from '~/core/pagination'

export type BaseResponse<T> = {
  info: T
  success?: boolean
}

export type AnnouncementsParams = { tag_id: EAnnouncementType; page_size: number; page: number }
export type AnnouncementsResponse = BaseResponse<
  Pagination<{
    // eslint-disable-next-line @typescript-eslint/naming-convention -- 老接口用的 Datas 字段
    Datas?: Announcement[]
    data?: Announcement[]
  }>
>

export interface Announcement {
  id: number
  title: string
  intro: string
  ctime: number
  utime: number
  maintagicon: string
  news: string
  notice: NumericBoolean
  to: string
}

export type AnnouncementDetailResponse = BaseResponse<AnnouncementDetail>

export type AnnouncementNoticeResponse = {
  code: number
  data: {
    notice: NumericBoolean
    notices: {
      [key in EAnnouncementType]: NumericBoolean
    }
  }
  message: string
}
export interface AnnouncementDetail {
  id: number
  creator: string
  author: string
  address: string
  title: string
  short_title: string | null
  intro: string
  news: string
  ctime: string
  utime: string
  cltimes: number
  uptimes: string
  downtimes: string
  replytimes: string
  typeid: string
  typename: string
  maintagid: string
  maintagname: string
  maintagicon: string
  notice: NumericBoolean
}

export enum EAnnouncementType {
  // 全站直播公告 ID
  LiveTag = 2420,
  // 主播工作台直播公告 ID
  LiveLiverTag = 2656,
  // 公会后台直播公告 ID
  LiveGuildTag = 2657,
}
